import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editSatus: null,
  showModal:null,
  profileEmail:null,
  profileMobile:null,
  navigation:null,
  password:null,
  scoreDetails:null
};

const DetailsofProfileSlice = createSlice({
  name: "profileDetails",
  initialState,
  reducers: {
    getEditStatus(state, action) {
      state.editSatus = action.payload;
    },
    getShowModal(state, action) {
      state.showModal = action.payload;
    },
    getProfileEmail(state, action) {
      state.profileEmail = action.payload;
    },
    getProfileMobile(state, action) {
      state.profileMobile = action.payload;
    },
    getNavigationPath(state, action) {
      state.navigation = action.payload;
    },
    getPassword(state, action) {
      state.password = action.payload;
    },
  getScoreDetails(state, action) {
      state.scoreDetails = action.payload;
    },
  },
});
export default DetailsofProfileSlice.reducer;
export const { getEditStatus, getShowModal, getProfileEmail, getProfileMobile, getNavigationPath, getPassword, getScoreDetails } = DetailsofProfileSlice.actions;
